import { render, staticRenderFns } from "./EditarArmaDialogComponent.vue?vue&type=template&id=2dc00235"
import script from "./EditarArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarArmaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports